import { AddAPhoto } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { FieldArrayWithId } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IAttachment } from "../../../common/models/IAttachment";
import FormAttachmentCard, { FormAttachmentActionCardEnum } from "../../forms/form-attachment-card/FormAttachmentCard";
import FormPropertySection from "../../forms/form-property-section/FormPropertySection";
import FormProperty from "../../forms/form-property/FormProperty";
import { CustomFormRunnerModeType } from "../CustomFormRunner";
import { CustomFormType } from "../CustomFormRunnerUtils";

export type CustomFormAttachmentsProps = {
    key?: React.Key | null | undefined,
    mode: CustomFormRunnerModeType | undefined,
    attachments: FieldArrayWithId<CustomFormType, "attachments", "fieldKey">[],
    onAttachmentAction: (action: FormAttachmentActionCardEnum,
        index: number,
        attachment: IAttachment) => void,
    onOpenCamera: () => void
};

export default function CustomFormAttachments({
  key,
  mode,
  attachments,
  onAttachmentAction,
  onOpenCamera
}: CustomFormAttachmentsProps) {

    const { t } = useTranslation();

     return (
         <FormPropertySection key={key} label={
             <Stack spacing={0} direction="row" sx={{
                 alignItems: "center"
             }}>
                 {mode === 'view' && attachments.length === 0 ? null :
                     <Typography component="span" variant="subtitle1" sx={{
                         fontWeight: 600
                     }} >
                         {t('customForms.attachments')}
                     </Typography>
                 }

                 {mode !== 'view' &&
                     <IconButton color="inherit" onClick={
                         () => onOpenCamera()
                     }>
                         <AddAPhoto />
                     </IconButton>
                 }

             </Stack>

             }>
             {attachments.map((field, index) => (
                 <FormProperty key={field.fieldKey}>
                     <FormAttachmentCard
                         disabled={mode === 'view'}
                         name={`attachments.${index}`}
                         index={index}
                         onAction={onAttachmentAction} />
                 </FormProperty>
             ))}
         </FormPropertySection>
     );
}
